import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { IoPrint } from "react-icons/io5";
import { GoDatabase } from "react-icons/go";
import { GenerateExcel, GenerateShapefile, GenerateKMZ, GenerateGDBfile } from "./DataExportUtils";
import PrintMap from '../PrintMap/PrintMap';
import './DataExport.css';
import { showAlert } from "../../../../utils/Helpers";
import { Modal } from "react-bootstrap";
import DivLoader from "../../../../components/common/Loader/DivLoader";
import DOMPurify from "dompurify";
import fetchDataWithAuth from "../../../../utils/api";
import { Link, useNavigate } from "react-router-dom";
import useScripts from "../../../../utils/UseScripts";

export const DataExport = ({ data, selected, mapview, resultCount, activeSearch }) => {
    const { t } = useTranslation();
    const [exportAllLayersChecked, setExportAllLayersChecked] = useState(false);
    const exportDivRef = useRef(null);
    const [printMap, setPrintMap] = useState(false);
    const [loading, showLoading] = React.useState(false);
    const navigate = useNavigate();
    const printRef = useRef(null); //
    const [scriptLoaded, setScriptLoaded] = useState(false);
    useScripts([
        `${process.env.PUBLIC_URL}/config/Config.js`
    ], () => {
        setScriptLoaded(true);
    });
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = sanitizeCSS(`
        .export-data{
            font-size: 0.875rem;

            .options{
                .option{
                    margin: 0 5px;
                    cursor: pointer;

                    &:not(.print){
                        &:hover{
                            opacity: 0.8;
                        }
                    }
                }
            }
        }
      `);

        exportDivRef.current.appendChild(style);
    }, []);

    const sanitizeCSS = (cssContent) => {
        return DOMPurify.sanitize(cssContent, { FORBID_ATTR: ["style"], FORBID_TAGS: ["script"] });
    };

    const exportData = async (type) => {
        showLoading(true);
        let payload = {};
        try {

            switch (type) {
                case 'excel':
                    GenerateExcel(data, selected, exportAllLayersChecked, activeSearch, t, "", () => {
                        showLoading(false); // Hide loading spinner once the task is complete
                        console.log('Excel export completed.');
                    });
                    payload = {
                        UserID: parseInt(localStorage.UserId) || 0,
                        SearchModule: activeSearch === "map" ? "Map Search" : "Data Search",
                        FeatureClassInfo: selected,
                        ExportedFormat: "Excel",
                        DownloadedDate: new Date().toISOString(),
                        SearchCriteria: ""
                    }
                    break;
                case 'shp':
                    GenerateShapefile(data, selected, exportAllLayersChecked, activeSearch, t, () => {
                        showLoading(false); // Hide loading spinner once the task is complete
                        console.log('Excel export completed.');
                    });
                    payload = {
                        UserID: parseInt(localStorage.UserId) || 0,
                        SearchModule: activeSearch === "map" ? "Map Search" : "Data Search",
                        FeatureClassInfo: selected,
                        ExportedFormat: "Shapefile",
                        DownloadedDate: new Date().toISOString(),
                        SearchCriteria: ""
                    }
                    break;
                case 'kmz':
                    GenerateKMZ(data, selected, exportAllLayersChecked, activeSearch, t, () => {
                        showLoading(false); // Hide loading spinner once the task is complete
                        console.log('Excel export completed.');
                    });
                    payload = {
                        UserID: parseInt(localStorage.UserId) || 0,
                        SearchModule: activeSearch === "map" ? "Map Search" : "Data Search",
                        FeatureClassInfo: selected,
                        ExportedFormat: "KMZ",
                        DownloadedDate: new Date().toISOString(),
                        SearchCriteria: ""
                    }
                    break;
                case 'gdb':
                    GenerateGDBfile(data, selected, exportAllLayersChecked, activeSearch, t, () => {
                        showLoading(false); // Hide loading spinner once the task is complete
                        console.log('Excel export completed.');
                    }, window.gpServiceUrl);
                    payload = {
                        UserID: parseInt(localStorage.UserId) || 0,
                        SearchModule: activeSearch === "map" ? "Map Search" : "Data Search",
                        FeatureClassInfo: selected,
                        ExportedFormat: "GDB",
                        DownloadedDate: new Date().toISOString(),
                        SearchCriteria: ""
                    }
                    break;
                default:
                    showLoading(false);
                    console.log('default export case')
                    break;
            }

            const apiResponse = await fetchDataWithAuth(
                `/PortalConfig/addDataExtrationlog`,
                "POST",
                navigate,
                t,
                payload
            );
            if (!apiResponse) {
                throw new Error(`Failed to log download: ${apiResponse.statusText}`);
            }
        }
        catch (err) {

            showAlert(t('dataExportFailed'), "error");
        }

    }

    const togglePrint = () => {
        setPrintMap((prevPrint) => !prevPrint);
    }

    return (
        <div id="data-export" ref={exportDivRef} className="export-data d-flex justify-content-between p-1">

            <div className="options d-flex inMobileHideExpo">
                <div className="excel option" title={t('excel')} onClick={() => exportData('excel')}>
                    {
                        <img src={`${process.env.PUBLIC_URL}/images/xlx.svg`} width={20} alt="" />
                    }
                </div>
                <div className="kmz option" title={t('kmz')} onClick={() => exportData('kmz')}>
                    <img
                        // src='./images/kmz.svg' 
                        src={`${process.env.PUBLIC_URL}/images/kmz.svg`}
                        width={20} alt="" />
                </div>
                <div className="shp option" title={t('shp')} onClick={() => exportData('shp')}>
                    <img
                        // src='./images/shp.svg'
                        src={`${process.env.PUBLIC_URL}/images/shp.svg`}
                        width={20} alt="" />
                </div>
                <div className="gdb option" title={t('gdb')} onClick={() => exportData('gdb')}>
                    <GoDatabase size={20} color={"#000"} />
                </div>
                <div className="print option" title={t('printlabel')} onClick={() => togglePrint()}>
                    <IoPrint size={20} color={"#000"} />

                </div>

            </div>

            <Modal
                show={printMap}
                onHide={() => setPrintMap(false)}
                size="md modal-dialog-centered"
                className="printMap-modal"
            >
                <Modal.Header closeButton className="border-btm-0 pe-4 pt-3 pb-0">
                    <h5>{"Print Map"}</h5>
                </Modal.Header>
                <Modal.Body className="pt-0 sm-full-ht">
                    <PrintMap mapview={mapview} printRef={printRef} />
                </Modal.Body>
            </Modal>
            {loading && <DivLoader />}
        </div>

    )
}
